module.exports = __webpack_public_path__ + "img/Reporting.0b05ce0d.png";